<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                id="closeoutline"
                d="M8,0 C12.418278,-8.11624501e-16 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 5.41083001e-16,12.418278 0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 Z M6.20009183,5.17157288 C5.91607416,4.88755521 5.45559054,4.88755521 5.17157288,5.17157288 C4.88755521,5.45559054 4.88755521,5.91607416 5.17157288,6.20009183 L5.17157288,6.20009183 L6.97045253,8 L5.17157288,9.79990817 C4.88755521,10.0839258 4.88755521,10.5444095 5.17157288,10.8284271 C5.45559054,11.1124448 5.91607416,11.1124448 6.20009183,10.8284271 L6.20009183,10.8284271 L7.99929289,9.02884037 L9.79990817,10.8284271 C10.0839258,11.1124448 10.5444095,11.1124448 10.8284271,10.8284271 C11.1124448,10.5444095 11.1124448,10.0839258 10.8284271,9.79990817 L10.8284271,9.79990817 L9.02813326,8 L10.8284271,6.20009183 C11.1124448,5.91607416 11.1124448,5.45559054 10.8284271,5.17157288 C10.5444095,4.88755521 10.0839258,4.88755521 9.79990817,5.17157288 L9.79990817,5.17157288 L7.99929289,6.97115963 Z"
            />
        </defs>
        <g id="Icons_Cancel" stroke="none" stroke-width="0" fill="none" fill-rule="evenodd">
            <mask id="mask-2" fill="white">
                <use xlink:href="#closeoutline" />
            </mask>
            <use id="Combined-Shape" :fill="color" xlink:href="#closeoutline" />
        </g>
    </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'CloseOutlineSVG',
    props: {
        size: VueTypes.integer.isRequired,
        color: VueTypes.string.isRequired,
    },
};
</script>

<style></style>
